import { useTranslation } from 'react-i18next';

import { ConfirmModal } from '@/components/feedback/ConfirmModal';

interface DeleteRoleConfirmModalProps {
  open: boolean;
  roleName: string;
  impactCount: number;
  isDeleting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

// Per PRD §3.4: confirm modal exposes the *actual* admin-impact count and
// guides the user on post-delete fallback behavior.
export function DeleteRoleConfirmModal({
  open,
  roleName,
  impactCount,
  isDeleting,
  onConfirm,
  onCancel,
}: DeleteRoleConfirmModalProps) {
  const { t } = useTranslation('roles');
  const message =
    impactCount > 0
      ? t('modals.deleteRole.affected', { name: roleName, count: impactCount })
      : t('modals.deleteRole.none', { name: roleName });

  return (
    <ConfirmModal
      open={open}
      title={t('modals.deleteRole.title')}
      message={message}
      confirmLabel={t('actions.delete')}
      cancelLabel={t('actions.cancel')}
      confirmVariant="destructive"
      loading={isDeleting}
      loadingLabel={t('actions.deleting')}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
}
